module.exports = __webpack_public_path__ + "static/img/major_pictgrid25_920x872.19fa02b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/major_pictgrid25_920x872.jpg
// module id = ozls
// module chunks = 0